module.exports = __webpack_public_path__ + "img/card-event-02-button.1247417c.svg";